/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, FeaturedListing } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateFeaturedListing(options?: Omit<(UseMutationOptions<(FeaturedListing | undefined), DefaultError, Prisma.FeaturedListingCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FeaturedListingCreateArgs, DefaultError, FeaturedListing, true>('FeaturedListing', 'POST', `${endpoint}/featuredListing/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FeaturedListingCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.FeaturedListingCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, FeaturedListing, Prisma.FeaturedListingGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.FeaturedListingCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, FeaturedListing, Prisma.FeaturedListingGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyFeaturedListing(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.FeaturedListingCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FeaturedListingCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('FeaturedListing', 'POST', `${endpoint}/featuredListing/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FeaturedListingCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.FeaturedListingCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.FeaturedListingCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyFeaturedListing<TArgs extends Prisma.FeaturedListingFindManyArgs, TQueryFnData = Array<Prisma.FeaturedListingGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/findMany`, args, options, fetch);
}

export function useInfiniteFindManyFeaturedListing<TArgs extends Prisma.FeaturedListingFindManyArgs, TQueryFnData = Array<Prisma.FeaturedListingGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/findMany`, args, options, fetch);
}

export function useSuspenseFindManyFeaturedListing<TArgs extends Prisma.FeaturedListingFindManyArgs, TQueryFnData = Array<Prisma.FeaturedListingGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyFeaturedListing<TArgs extends Prisma.FeaturedListingFindManyArgs, TQueryFnData = Array<Prisma.FeaturedListingGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/findMany`, args, options, fetch);
}

export function useFindUniqueFeaturedListing<TArgs extends Prisma.FeaturedListingFindUniqueArgs, TQueryFnData = Prisma.FeaturedListingGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueFeaturedListing<TArgs extends Prisma.FeaturedListingFindUniqueArgs, TQueryFnData = Prisma.FeaturedListingGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/findUnique`, args, options, fetch);
}

export function useFindFirstFeaturedListing<TArgs extends Prisma.FeaturedListingFindFirstArgs, TQueryFnData = Prisma.FeaturedListingGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstFeaturedListing<TArgs extends Prisma.FeaturedListingFindFirstArgs, TQueryFnData = Prisma.FeaturedListingGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/findFirst`, args, options, fetch);
}

export function useUpdateFeaturedListing(options?: Omit<(UseMutationOptions<(FeaturedListing | undefined), DefaultError, Prisma.FeaturedListingUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FeaturedListingUpdateArgs, DefaultError, FeaturedListing, true>('FeaturedListing', 'PUT', `${endpoint}/featuredListing/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FeaturedListingUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.FeaturedListingUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, FeaturedListing, Prisma.FeaturedListingGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.FeaturedListingUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, FeaturedListing, Prisma.FeaturedListingGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyFeaturedListing(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.FeaturedListingUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FeaturedListingUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('FeaturedListing', 'PUT', `${endpoint}/featuredListing/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FeaturedListingUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.FeaturedListingUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.FeaturedListingUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertFeaturedListing(options?: Omit<(UseMutationOptions<(FeaturedListing | undefined), DefaultError, Prisma.FeaturedListingUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FeaturedListingUpsertArgs, DefaultError, FeaturedListing, true>('FeaturedListing', 'POST', `${endpoint}/featuredListing/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FeaturedListingUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.FeaturedListingUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, FeaturedListing, Prisma.FeaturedListingGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.FeaturedListingUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, FeaturedListing, Prisma.FeaturedListingGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteFeaturedListing(options?: Omit<(UseMutationOptions<(FeaturedListing | undefined), DefaultError, Prisma.FeaturedListingDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FeaturedListingDeleteArgs, DefaultError, FeaturedListing, true>('FeaturedListing', 'DELETE', `${endpoint}/featuredListing/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FeaturedListingDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.FeaturedListingDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, FeaturedListing, Prisma.FeaturedListingGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.FeaturedListingDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, FeaturedListing, Prisma.FeaturedListingGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyFeaturedListing(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.FeaturedListingDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FeaturedListingDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('FeaturedListing', 'DELETE', `${endpoint}/featuredListing/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FeaturedListingDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.FeaturedListingDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.FeaturedListingDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateFeaturedListing<TArgs extends Prisma.FeaturedListingAggregateArgs, TQueryFnData = Prisma.GetFeaturedListingAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateFeaturedListing<TArgs extends Prisma.FeaturedListingAggregateArgs, TQueryFnData = Prisma.GetFeaturedListingAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/aggregate`, args, options, fetch);
}

export function useGroupByFeaturedListing<TArgs extends Prisma.FeaturedListingGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.FeaturedListingGroupByArgs['orderBy'] } : { orderBy?: Prisma.FeaturedListingGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.FeaturedListingGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.FeaturedListingGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.FeaturedListingGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.FeaturedListingGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.FeaturedListingGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByFeaturedListing<TArgs extends Prisma.FeaturedListingGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.FeaturedListingGroupByArgs['orderBy'] } : { orderBy?: Prisma.FeaturedListingGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.FeaturedListingGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.FeaturedListingGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.FeaturedListingGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.FeaturedListingGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.FeaturedListingGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/groupBy`, args, options, fetch);
}

export function useCountFeaturedListing<TArgs extends Prisma.FeaturedListingCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.FeaturedListingCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/count`, args, options, fetch);
}

export function useSuspenseCountFeaturedListing<TArgs extends Prisma.FeaturedListingCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.FeaturedListingCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FeaturedListingCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FeaturedListing', `${endpoint}/featuredListing/count`, args, options, fetch);
}

export function useCheckFeaturedListing<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; listingId?: string }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('FeaturedListing', `${endpoint}/featuredListing/check`, args, options, fetch);
}
